module.exports = __webpack_public_path__ + "img/1512.fe2c2240.jpg";